export class NetworkError extends Error {
  constructor(
    message: string,
    public readonly statusCode?: number,
    public readonly originalError?: unknown
  ) {
    super(message);
    this.name = "NetworkError";
    Object.setPrototypeOf(this, new.target.prototype);
  }
}

export class OfflineError extends NetworkError {
  constructor(message = "Device is offline", originalError?: unknown) {
    super(message, 0, originalError);

    this.name = "OfflineError";
    Object.setPrototypeOf(this, new.target.prototype);
  }
}

export class UnauthorizedError extends NetworkError {
  constructor(message = "Unauthorized", statusCode = 401, originalError?: unknown) {
    super(message, statusCode, originalError);
    this.name = "UnauthorizedError";
    Object.setPrototypeOf(this, new.target.prototype);
  }
}

export class ServerError extends NetworkError {
  constructor(message = "Internal Server Error", statusCode = 500, originalError?: unknown) {
    super(message, statusCode, originalError);
    this.name = "ServerError";
    Object.setPrototypeOf(this, new.target.prototype);
  }
}
